export enum Align {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}

/*
We use the default DLS Brand Colors
More info: https://design.aexp.com/language/style/color/
*/
export enum Color {
  LighterBlue = 'lighter-blue',
  BrightBlue = 'bright-blue',
  DeepBlue = 'deep-blue',
  White = 'white',
  Black = 'black',
  Gray01 = 'gray-01',
  Gray02 = 'gray-02',
  Gray03 = 'gray-03',
  Gray04 = 'gray-04',
  Gray05 = 'gray-05',
  Gray06 = 'gray-06',
  Green = 'green',
  Red = 'red',
  StatusSuccess = 'status-success',
  StatusAttention = 'status-attention',
  StatusModerate = 'status-moderate',
  StatusWarning = 'status-warning',
  Transparent = 'transparent',
}

export enum FontType {
  BentonLight = 'benton_light',
  BentonRegular = 'benton_regular',
  BentonMedium = 'benton_medium',
  BentonBold = 'benton_bold',
  BentonBook = 'benton_book',
  BentonBlack = 'benton_black',
  HelveticaRegular = 'helvetica_regular',
  HelveticaBold = 'helvetica_bold',
}

export enum TextPosition {
  Next = 'next',
  Below = 'below',
}

export enum VAlign {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

export enum Position {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
}

export enum ButtonType {
  A,
  Link,
  Button,
}

export enum Type {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export enum Size {
  DLS_XS = 'dls_xs',
  DLS_SM = 'dls_sm',
  DLS_MD = 'dls_md',
  DLS_LG = 'dls_lg',
  DLS_XL = 'dls_xl',

  XXS = 'xxs',
  XS = 'xs',
  SMX = 'sm-x',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
  Auto = 'auto',
  None = 'none',
}

export enum Direction {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum AnchorTarget {
  Blank = '_blank',
  Self = '_self',
  Parent = '_parent',
  Top = '_top',
}
